import {
  HoveredEvents,
  PAEventType
} from '@dadohr/shared/domainTypes/productAnalytics';
import { Tooltip, Typography } from '@material-ui/core';
import { Info } from 'lucide-react';
import { useState } from 'react';
import { useUnsafeTranslation } from '../../../../i18next';
import { FlexContainer } from '../../../../layout/Flex';
import { useProductAnalytics } from '../../../../services/productAnalytics';

type TrackingInfo = {
  name: HoveredEvents;
  explanation: string;
};

export const ChartTitle = ({
  title,
  tooltipText
}: {
  title: string;
  tooltipText: string;
}) => {
  const { t } = useUnsafeTranslation();
  const { trackEvent } = useProductAnalytics();

  const [open, setOpen] = useState<boolean>(false);

  const trackingInfo: Record<string, TrackingInfo> = {
    'Completion per task': {
      name: 'Completion Per Tasks Chart Tooltip Hovered',
      explanation:
        'Admin user hovered over the explanatory tooltip next to the bar chart showing completion rate per task'
    },
    'Participants starting new experiences': {
      name: 'Participants Chart Tooltip Hovered',
      explanation:
        'Admin user hovered over the explanatory tooltip next to the line chart showing the number of participants who started an experience per week/month/cohort'
    },
    'Completion per cohort': {
      name: 'Completion Per Cohort Chart Tooltip Hovered',
      explanation:
        'Admin user hovered over the explanatory tooltip next to the heat map showing completion rate per task and per cohort'
    },
    'Total tasks': {
      name: 'Tasks By Status Chart Tooltip Hovered',
      explanation:
        'Admin user hovered over the explanatory tooltip next to the stacked bar chart showing tasks per week/month/cohort, by status'
    }
  };
  return (
    <FlexContainer alignItems="center" spacing={2}>
      <Typography variant="h4">{t(title)}</Typography>
      {tooltipText && (
        <Tooltip
          title={tooltipText}
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => {
            setOpen(true);
            Object.keys(trackingInfo).forEach((info: string) => {
              if (info === title) {
                trackEvent({
                  eventType: PAEventType.OTHER,
                  name: trackingInfo[info].name,
                  Explanation: trackingInfo[info].explanation
                });
              }
            });
          }}
        >
          <Info size={20} color="lightgray" />
        </Tooltip>
      )}
    </FlexContainer>
  );
};
